export enum SearchTypes {
  ADVANCED = 'ADVANCED_SEARCH',
  ALPHA = 'ALPHA_SEARCH',
  ARTICLE = 'ARTICLE_SEARCH',
}
